import { ComponentResource } from '@/api/serverApi'
import { RootState } from '@/stores'
import { useSelector } from 'react-redux'

export interface useComponentParentResult {
  parent: ComponentResource | null
}

type PropTypes = {
  component?: ComponentResource | null | undefined
}

const useComponentParent = ({ component }: PropTypes): useComponentParentResult => {
  const components = useSelector((state: RootState) => state.activeDesign.design?.components)

  return {
    parent: component ? components?.find(c => c.id === component.parent_id) ?? null : null,
  }
}

export default useComponentParent
